var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTechnicalService(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.843 17.023a.5.5 0 010 .707l-1.99 1.992a.5.5 0 01-.707-.706l1.99-1.993a.5.5 0 01.707 0zM14.422 7.443a.5.5 0 010 .707l-2.004 2.004a.5.5 0 01-.707-.707l2.004-2.004a.5.5 0 01.707 0z",
    fill: "#8D94A5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.352 14.864a.661.661 0 00-.484.2l-.006.006a.693.693 0 000 .982l1 .99a.693.693 0 00.983 0l.002-.001a.692.692 0 000-.981l-1.007-.998a.644.644 0 00-.473-.198h-.015zm2.201 2.885a1.693 1.693 0 01-2.397 0l-.998-.987-.001-.001a1.693 1.693 0 01-.003-2.397 1.663 1.663 0 011.207-.5 1.643 1.643 0 011.195.5l.996.986a1.692 1.692 0 01.001 2.399z",
    fill: "#8D94A5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.826 12.643a.697.697 0 00-.983.985l1.73 1.733a.735.735 0 00.995.001.703.703 0 00.2-.49v-.003a.681.681 0 00-.201-.485h-.001l-1.74-1.74zm-.496-1.19c.443-.005.87.164 1.191.47l.008.009 1.743 1.743a1.684 1.684 0 01.495 1.197c0 .45-.178.883-.497 1.202l-.011.011a1.735 1.735 0 01-2.376 0l-.012-.01-1.748-1.752a1.697 1.697 0 011.207-2.87z",
    fill: "#8D94A5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.263 10.773a.697.697 0 00-.268-.053h-.002a.678.678 0 00-.484.203l-.003.002a.696.696 0 000 .984l1.746 1.745a.692.692 0 00.983 0v-.001a.695.695 0 000-.984l-1.744-1.744a.7.7 0 00-.228-.152zm-.27-1.053a1.697 1.697 0 011.205.498l1.744 1.744a1.695 1.695 0 11-2.398 2.398L5.8 12.617A1.697 1.697 0 016.993 9.72zm0 0v.5l-.001-.5z",
    fill: "#8D94A5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.57 9.622a.66.66 0 00-.199.48v.017a.64.64 0 00.196.472l.01.009.98.992a.743.743 0 00.791.14.034.034 0 00.02-.032l-.001-.023v-.1a.5.5 0 011 0v.09a1.035 1.035 0 01-.622.983l-.003.002a1.743 1.743 0 01-1.89-.35l-.984-.996a1.64 1.64 0 01-.497-1.197 1.66 1.66 0 01.505-1.208l.006-.006a1.735 1.735 0 012.39.014l.944.962a.828.828 0 01.03.032l.009.01a.5.5 0 01-.74.673l-.01-.012-.004-.004-.935-.952a.735.735 0 00-.997.004zM5.966 18.659a.5.5 0 01.707 0l1.674 1.672a.5.5 0 11-.707.708l-1.674-1.673a.5.5 0 010-.707z",
    fill: "#8D94A5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.283 10.471a.653.653 0 00-.922.922l1.33 1.328a.5.5 0 01-.002.71l-7.721 7.617a.5.5 0 11-.702-.712l7.362-7.263-.983-.98a1.652 1.652 0 012.337-2.337l.005.005 1.628 1.63a3.576 3.576 0 010 5.056l-.266.267a1.806 1.806 0 00.018 2.571l.991 1.107a.5.5 0 01-.745.667l-.982-1.097a2.806 2.806 0 01.01-3.954m-1.358-5.537l1.625 1.626a2.576 2.576 0 010 3.642l-.267.269",
    fill: "#8D94A5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.217 9.195a.5.5 0 010 .707L14.32 11.8a.5.5 0 11-.708-.707l1.898-1.898a.5.5 0 01.707 0z",
    fill: "#8D94A5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.392 2.49a.5.5 0 01-.142.417l-.972.972a.5.5 0 11-.707-.707l.47-.47a3.5 3.5 0 102.12 2.122l-.822.822a.5.5 0 01-.707-.707l1.325-1.325a.5.5 0 01.784.1 4.502 4.502 0 01-7.059 5.468 4.5 4.5 0 015.468-7.059.5.5 0 01.242.368z",
    fill: "#8D94A5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.632 2.818a.5.5 0 010 .707L17.657 5.5v.707h.707l1.975-1.975a.5.5 0 01.707.707l-2.121 2.122a.5.5 0 01-.354.146h-1.414a.5.5 0 01-.5-.5V5.293a.5.5 0 01.146-.354l2.122-2.121a.5.5 0 01.707 0z",
    fill: "#8D94A5"
  })));
}
export default __webpack_public_path__ + "static/technical-service.5cf29d55.svg";
export { SvgTechnicalService as ReactComponent };